<template>
<section class="hero is-fullheight" style="overflow:none">
  <div class="column is-10">
    <p class="content has-text-centered"><b>{{videoName}}</b></p>
    <div class="card-content">
      <video width="950" controls controlsList="nodownload" :src="video.src" autoplay></video>
    </div>
  </div>
</section>
</template>

<script>
import constants from '@/utils/constants'
export default {
  name: 'videoplayer',
  props: ['urlPath', 'videoName'],
  data () {
    return {
      video: {
        src: ''
      }
    }
  },
  async created () {
    try {
      this.loadingComponent = this.$buefy.loading.open()
      let response = await http.get(`${constants.API_URL}/api/franchisee/get-video-base-url`)
      if (response.data) {
        this.video.src = `${response.data}${encodeURI(decodeURIComponent(this.urlPath))}`
        console.log(this.video.src)
        if (window.location.origin === 'https://stagetotsadmin.fcintelli.tech' ||
        window.location.origin === 'http://localhost:8081') {
          this.video.src = 'https://intelliplay-videos.s3.ap-south-1.amazonaws.com/intellitots%2FFranchiseeVideoLessons%2Fproduction%2F53%2F254%2F7%2F11.+Built+in+Functions+1.1.mp4'
        }
      } else {
        return this.$buefy.toast.open({
          message: 'Failed to load a video!',
          type: 'is-danger',
          duration: 4000
        })
      }
    } catch (e) {
      console.log(e)
      return this.$buefy.toast.open({
        message: 'Error occurred while loading video!',
        type: 'is-danger',
        duration: 4000
      })
    } finally {
      this.loadingComponent.close()
    }
  }
}
</script>
<style scoped lang="scss">
.card-content {
    transition: box-shadow 0.50s, -webkit-box-shadow 0.25s;
    box-shadow: 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.3);
}

.hero.is-fullheight {
  position: relative;
    top: 0;
    bottom: 0;
    left: 10px;
    right: 0;
    overflow: none;
}
</style>
